import { AppProviders, LibraryProviders } from "web/Providers"
import { BrowserRouter as Router } from "react-router-dom"
import { Controller } from "@hotwired/stimulus"
import { Loading, ModalContainer } from "web/components"
import { render, unmountComponentAtNode } from "react-dom"
import { TLOContextProvider } from "web/contexts"
import { usePortfolio } from "web/hooks/data"
import React, { Suspense } from "react"
import PortfolioAllocations from "web/app/Portfolios/PortfolioAllocations"

export default class PortfolioAllocationsController extends Controller {
  static values = {
    portfolioId: Number,
  }

  initialize() {
    global.React = React
  }

  connect() {
    const PortfolioTLOContextProvider = ({ children }) => {
      return (
        <TLOContextProvider
          subjectType="portfolio"
          data={usePortfolio(this.portfolioIdValue)}
        >
          {children}
        </TLOContextProvider>
      )
    }

    render(
      <Suspense fallback={<Loading />}>
        <Router>
          <LibraryProviders>
            <AppProviders>
              <PortfolioTLOContextProvider>
                <PortfolioAllocations />
              </PortfolioTLOContextProvider>
              <ModalContainer />
            </AppProviders>
          </LibraryProviders>
        </Router>
      </Suspense>,
      this.element
    )
  }

  disconnect() {
    unmountComponentAtNode(this.element)
  }
}
